import { createSelector } from "reselect"
import { get, find, map } from "lodash"
import { getContentSets } from "selectors/contentSets"
import { getGroup, menuContentSets } from "helpers/menu"
import { getBaseComparisonTypes } from "helpers/comparison"
import { getIsOpPro } from "modules/account-root/selectors"
import { canSegmentBeDisplayed } from "modules/compare-risk/helpers"

const EMPTY_ARRAY = []
const EMPTY_OBJECT = {}

const getRawComparisonTypes = (state, props) => get(props, "comparisonTypes")
const getRawSelectedComparisonType = (state, props) => get(props, "selectedComparisonType", EMPTY_OBJECT)
const getPropComparisonItems = (_, props) => get(props, "comparisonItems", EMPTY_ARRAY)
const getPropIsActive = (_, props) => get(props, "isActive")

const getComparisonTypes = createSelector(
  [getContentSets, getRawComparisonTypes, getIsOpPro],
  (contentSets, comparisonTypes, isOpPro) => {
    return comparisonTypes || [
      ...getBaseComparisonTypes(isOpPro),
      ...menuContentSets(contentSets),
    ]
  },
)

export const getSelectedComparisonType = createSelector(
  [getRawSelectedComparisonType, getComparisonTypes],
  (selectedComparisonType, comparisonTypes) => {
    return find(comparisonTypes, { id: selectedComparisonType.id }) ?? comparisonTypes[0]
  },
)

export const getMenuItems = createSelector(
  [getComparisonTypes],
  (types) => map(types, (type, i) => ({
    order: i,
    id: type.id,
    label: type.name,
    ...getGroup(type),
    ...type,
  })),
)

export const getComparisonItems = createSelector(
  [getPropComparisonItems, getSelectedComparisonType, getPropIsActive],
  (comparisonItems, selectedComparisonType, isActive) => {
    const isRisk = get(selectedComparisonType, "id") === "risk"
    return map(comparisonItems, (item, index) => ({
      ...item,
      ...(isRisk && { riskAdjusted: !canSegmentBeDisplayed(get(comparisonItems, index), isActive) }),
    }))
  },
)
